import Vue from 'vue';
import tooltip from '@/directives/tooltip';

Vue.directive('tooltip', tooltip);
